// Portuguese (Portugal) (pt-PT)
export default {
  // --- Shell / nav ---
  app_name: 'Marés próximas',
  search_stations: 'Pesquisar estações',
  search_stations_hint: 'Pesquisar estações (⌘K)',
  settings: 'Definições',
  app_store: 'Transferir na App Store',
  google_play: 'Disponível no Google Play',
  app_promo_title: 'Descarregue a app gratuita. É mais rápida 🙂',
  app_promo_body: 'As mesmas previsões de marés e correntes, no seu telemóvel.',
  privacy: 'Privacidade',
  terms: 'Termos',
  data_sources: 'Fontes de dados',
  support: 'Suporte',

  guides: 'Guias',
  // --- Home ---
  home_title: 'Encontre marés e correntes nas proximidades',
  by_country: 'Por país',
  favorite_tides: 'Marés favoritas',
  recent_tides: 'Marés recentes',
  nearby_tides: 'Marés nas proximidades',
  favorite_currents: 'Correntes favoritas',
  recent_currents: 'Correntes recentes',
  nearby_currents: 'Correntes nas proximidades',
  favorite_charts: 'Cartas náuticas favoritas',
  recent_charts: 'Cartas náuticas recentes',
  nearby_charts: 'Cartas náuticas nas proximidades',
  finding_stations: 'A procurar estações perto de si…',
  distance_away: 'A {{distance}} de distância',

  // --- Search overlay ---
  search_placeholder: 'Pesquisar estações…',
  tide_stations: 'Estações de marés',
  current_stations: 'Estações de correntes',
  recents: 'Recentes',
  search_unavailable: 'A pesquisa está indisponível de momento.',
  no_stations_found: 'Nenhuma estação encontrada.',
  search_prompt: 'Pesquise estações de marés e correntes por nome.',

  // --- Settings ---
  appearance: 'Aparência',
  appearance_system: 'Sistema',
  appearance_light: 'Claro',
  appearance_dark: 'Escuro',
  tide_height: 'Altura da maré',
  unit_feet: 'Pés',
  unit_meters: 'Metros',
  distance: 'Distância',
  unit_miles: 'Milhas',
  unit_kilometers: 'Quilómetros',
  recent_stations: 'Estações recentes',
  clear_recents: 'Limpar recentes',
  currents: 'Correntes',
  nautical_charts: 'Cartas náuticas',
  browse_by_country: 'Explorar por país',
  countries_auto: 'Automático',
  countries_always: 'Sempre',
  countries_never: 'Nunca',
  show: 'Mostrar',
  hide: 'Ocultar',

  // --- Station pages (tide + current) ---
  tide_title: 'Marés de {{name}}',
  current_title: 'Correntes de {{name}}',
  last_tide: 'Última maré',
  next_tide: 'Próxima maré',
  coefficient: 'Coef',
  last_current: 'Última corrente',
  next_current: 'Próxima corrente',
  following_current: 'Corrente seguinte',
  high: 'Alta',
  low: 'Baixa',
  tides: 'Marés',
  sun: 'Sol',
  moon: 'Lua',
  sunrise_now: 'Nascer do sol',
  sunset_now: 'Pôr do sol',
  moonrise_now: 'Nascimento da lua',
  moonset_now: 'Ocaso da lua',
  sunrise_week: 'Nascer',
  sunset_week: 'Pôr',
  moonrise_week: 'Nascimento',
  moonset_week: 'Ocaso',
  add_to_favorites: 'Adicionar aos favoritos',
  remove_from_favorites: 'Remover dos favoritos',

  // --- Week table dates ---
  today: 'Hoje',
  tomorrow: 'Amanhã',

  // --- Moon phases ---
  phase_new_moon: 'Lua nova',
  phase_waxing_crescent: 'Crescente côncava',
  phase_first_quarter: 'Quarto crescente',
  phase_waxing_gibbous: 'Crescente convexa',
  phase_full_moon: 'Lua cheia',
  phase_waning_gibbous: 'Minguante convexa',
  phase_last_quarter: 'Quarto minguante',
  phase_waning_crescent: 'Minguante côncava',

  // --- Tide / current status vocabulary ---
  rising: 'A subir',
  falling: 'A descer',
  high_tide: 'Preia-mar',
  low_tide: 'Baixa-mar',
  ebb: 'Vazante',
  flood: 'Enchente',
  slack: 'Estofo',

  // --- Relative time ---
  just_now: 'Agora',
  somethings_wrong: 'Ocorreu um erro',
  hour_ago: 'Há {{hour}} hora',
  hours_ago: 'Há {{hour}} horas',
  minute_ago: 'Há {{minute}} minuto',
  minutes_ago: 'Há {{minute}} minutos',
  hour_minute_ago: 'Há {{hour}} hora e {{minute}} minuto',
  hour_minutes_ago: 'Há {{hour}} hora e {{minute}} minutos',
  hours_minute_ago: 'Há {{hour}} horas e {{minute}} minuto',
  hours_minutes_ago: 'Há {{hour}} horas e {{minute}} minutos',
  hour_from_now: 'Daqui a {{hour}} hora',
  hours_from_now: 'Daqui a {{hour}} horas',
  minute_from_now: 'Daqui a {{minute}} minuto',
  minutes_from_now: 'Daqui a {{minute}} minutos',
  hour_minute_from_now: 'Daqui a {{hour}} hora e {{minute}} minuto',
  hour_minutes_from_now: 'Daqui a {{hour}} hora e {{minute}} minutos',
  hours_minute_from_now: 'Daqui a {{hour}} horas e {{minute}} minuto',
  hours_minutes_from_now: 'Daqui a {{hour}} horas e {{minute}} minutos',

  // --- Insights ---
  insights_7_day_overview: 'Informações de 7 dias',
  no_insights_available: 'Nenhuma informação disponível para esta estação.',
  insights_current_extremes: 'Extremos de corrente',
  insights_fastest_flood: 'Enchente mais rápida',
  insights_fastest_ebb: 'Vazante mais rápida',
  insights_strongest_daily_currents: 'Correntes diárias máximas',
  insights_fastest_current: 'Mais rápida',
  insights_slowest_current: 'Mais lenta',
  insights_tidal_extremes: 'Extremos de maré',
  insights_highest_tide: 'Maré mais alta',
  insights_lowest_tide: 'Maré mais baixa',
  insights_strongest_daily_movements: 'Maiores amplitudes de maré',
  insights_largest_tide: 'Maior',
  insights_smallest_tide: 'Menor',
  insights_value_at_time: '{{value}} às {{time}}',
  insights_tidal_range_label: 'amplitude de maré',
  insights_max_current_label: 'corrente máxima',

  // --- Insight bands ---
  band_smaller_than_usual: 'Menor que o habitual',
  band_typical: 'Típico',
  band_larger_than_usual: 'Maior que o habitual',
  band_unusually_large: 'Excecionalmente grande',
  band_lower_than_usual: 'Mais baixa que o habitual',
  band_unusually_low: 'Excepcionalmente baixa',
  band_slower_than_usual: 'Mais lenta que o habitual',
  band_faster_than_usual: 'Mais rápida que o habitual',
  band_unusually_fast: 'Excecionalmente rápida',
  band_smaller_than_usual_height: 'Mais baixo que o habitual',
  band_larger_than_usual_height: 'Mais alto que o habitual',
  band_unusually_large_height: 'Excecionalmente alto',

  // --- Map attribution ---
  attribution: 'Atribuição',
  attribution_osm: 'Dados do mapa © Contribuidores do OpenStreetMap',
  attribution_tiles: 'Mosaicos de mapa por OpenFreeMap',
  attribution_style: 'Estilo do mapa © OpenMapTiles',
  ok: 'OK',

  // --- Explore map ---
  current_speed: 'Velocidade da corrente',
  depth: 'Profundidade',
  speed: 'Velocidade',
  depth_datum: 'Profundidades a partir de',
  depth_drying: 'Seca',
  depth_loading: 'A carregar dados de profundidade…',
  depth_datum_tag: 'Profundidades em {{unit}} abaixo de {{datum}}',
  depth_not_for_navigation: 'Não utilizar para navegação.',
  depth_unavailable: 'Os dados de profundidade não estão disponíveis neste momento.',
  depth_unit_m: 'm',
  depth_unit_ft: 'ft',
  go_mode_start: 'IR',
  go_mode_start_label: 'Iniciar',
  go_mode_exit: 'Sair',
  go_mode_location_denied:
    'O modo Go precisa da sua localização. Ative-o através do ícone de cadeado.',
  go_mode_location_denied_ok: 'OK',
  radar: 'Radar',
  radar_precipitation: 'Precipitação',
  radar_light: 'fraca',
  radar_moderate: 'moderada',
  radar_heavy: 'forte',
  radar_storm: 'torrencial',
  radar_forecast: 'previsão',
  radar_none_for_time: 'sem radar para esta hora',
  now: 'Agora',
  explore_prompt_denied:
    'A localização está desativada para este site: ative-a através do ícone de cadeado na barra de endereço.',
  open_full_map: 'Abrir o mapa completo',
  close_full_map: 'Fechar o mapa completo',
  explore_full_map: 'Explore o mapa completo',
  center_on_location: 'Centrar na minha localização',
  show_my_location: 'Mostrar a minha localização',
  map_knots_label: '{{speed}} kt',

  // --- Location pages ---
  states: 'estados',
  no_stations_found_location: 'Nenhuma estação encontrada.',
  tides_and_currents_by_country: 'Marés e correntes por país',

  // --- SEO titles / descriptions ---
  settings_seo_description: 'Escolha as suas unidades para alturas de marés e distâncias.',
  tide_seo_description:
    'Previsões de marés, horários de maré alta e baixa para {{name}}{{location}}.',
  current_seo_description:
    'Previsões de correntes de maré, horários de enchente e vazante para {{name}}{{location}}.',
  location_title: 'Marés e correntes de {{name}}',
  country_seo_description:
    'Horários de marés e previsões de correntes de maré para {{name}}. Explore {{stateTerm}} e estações de marés costeiras em {{name}}.',
  state_seo_description:
    'Previsões de marés e correntes para {{name}}, {{country}}. Horários de maré alta e baixa para estações costeiras em {{name}}.',
  city_seo_description:
    'Horários de marés e previsões de correntes de maré para {{place}}. Marés altas e baixas e correntes perto de {{name}}.',
  // --- Chart pages (chart titles, numbers and purposes stay in the
  // issuing authority's language: they name a specific printed sheet) ---
  charts_for_station: 'Cartas náuticas de {{name}}',
  chart_intro:
    'Carta náutica gratuita de {{title}}: profundidades levantadas, boias, balizas, rochas, naufrágios, marinas, ancoradouros e estações de marés.',
  chart_page_name: 'Carta náutica de {{title}}',
  chart_seo_description:
    'Carta náutica gratuita de {{title}}: profundidades levantadas, boias, balizas, rochas, naufrágios, marinas, ancoradouros e estações de marés.',

  countries_seo_title: 'Estações de marés e correntes por país',
  countries_seo_description:
    'Explore estações de marés e correntes por país. Horários de maré alta e baixa e previsões de correntes de maré para localidades costeiras em todo o mundo.',
  home_seo_description:
    'Encontre horários de marés e previsões de correntes de maré para estações costeiras perto de si. Veja a maré alta e baixa da sua localização ou explore estações por país.',
  explore_play: 'Reproduzir',
  explore_pause: 'Pausar',
  explore_playback_speed: 'Velocidade de reprodução',
  explore_time: 'Hora',
  skip_to_content: 'Saltar para o conteúdo principal',
  // --- Weather (station pages) ---
  weather: 'Meteorologia marítima',
  wind: 'Vento',
  gusts: 'Rajadas',
  seas: 'Ondas',
  time: 'Hora',
  air_temp: 'Ar',
  water_temp: 'Água',
  water_temperature: 'Temperatura da água',
  humidity: 'Humidade',
  pressure: 'Pressão',
  precip_chance: 'Precipitação',
  chances: 'Probabilidade',
  precip_rate: 'Intensidade de precipitação',
  visibility: 'Visibilidade',
  condition_thunderstorms: 'Trovoadas',
  condition_freezing_rain: 'Chuva congelante',
  condition_sleet: 'Água-neve',
  condition_snow: 'Neve',
  condition_fog: 'Nevoeiro',
  condition_rain: 'Chuva',
  condition_cloudy: 'Nublado',
  condition_partly_cloudy: 'Parcialmente nublado',
  condition_clear: 'Céu limpo',
  weather_thunder: 'Trovoada',
  note_seas_computed_from_wind:
    'A altura das ondas é estimada a partir do vento e da linha de costa.',
  note_seas_from_nearby_open_water: 'O estado do mar provém de águas abertas próximas.',
  note_seas_open_water_nearby:
    'As ondas nas águas abertas próximas rondam {{height}}. Aqui pode estar mais calmo.',
  note_seas_open_water_distant:
    'As ondas em águas abertas a {{distance}} rondam {{height}}. Aqui pode estar mais calmo.',
  note_seas_open_water_distant_dir:
    'As ondas em águas abertas a {{distance}} a {{direction}} daqui rondam {{height}}. Aqui pode estar mais calmo.',
  note_seas_unavailable: 'Não há estado do mar fiável para este ponto.',
  note_sheltered_water_sees_less:
    'Em águas abrigadas o mar costuma ser menor do que estes valores de mar aberto.',
  note_no_warning_feed_coverage: 'Nenhum serviço oficial de avisos marítimos cobre este ponto.',
  note_nearest_point_across_land: 'O ponto de previsão mais próximo fica do outro lado de terra.',
  warnings_none_active: 'Sem avisos marítimos em vigor',
  warnings_unavailable: 'Os avisos marítimos não estão disponíveis para este local',
  warning_show_text: 'Mostrar texto oficial',
  warning_hide_text: 'Ocultar texto oficial',
  weather_updated: 'Atualizado {{time}}',
  current_conditions: 'Condições atuais',
  daily_forecast: 'Previsão diária',
  expand_for_hourly: 'Expandir para ver por hora',
  hourly: 'Por hora',
  hourly_forecast: 'Previsão horária',
  wind_speed: 'Velocidade do vento',
  wind_gusts: 'Vento e rajadas',
  pressure_humidity: 'Pressão e humidade',
  max_seas: 'Ondulação máxima',
  visibility_excellent: 'Excelente',
  visibility_good: 'Boa',
  visibility_moderate: 'Moderada',
  visibility_poor: 'Fraca',
  forecaster_text_link: 'Texto de previsão de {{issuer}}',
  temperature: 'Temperatura',
  unit_fahrenheit: 'Fahrenheit',
  unit_celsius: 'Celsius',
  // --- Conditions summary (station pages) ---
  // Sea state: WMO Sea State Code. Wind: Beaufort. Both are published
  // scales with standard terminology in each language, not our own wording.
  // Warning-window and low–high range punctuation. CJK marks a range (and
  // an open end) with ～, not an en dash or a trailing plus.
  warning_window_range: '{{start}} – {{end}}',
  warning_window_open: '{{start}}+',
  range_separator_short: '-',
  // Wave-period fragments. The connector is the locale's own word for the
  // "at" in "0.5 m S @ 3s" (CJK says "period" instead); the value carries
  // the locale's seconds notation (秒/초 — bare Latin "s" reads as an
  // untranslated fragment in CJK weather products).
  seas_period_at: 'a',
  wave_period_short: '{{period}}s',
  // 16-point compass, per this locale’s meteorological convention — the
  // letters differ across languages (Z/O/Ø/V…) and CJK writes the words out.
  compass_N: 'N',
  compass_NNE: 'NNE',
  compass_NE: 'NE',
  compass_ENE: 'ENE',
  compass_E: 'E',
  compass_ESE: 'ESE',
  compass_SE: 'SE',
  compass_SSE: 'SSE',
  compass_S: 'S',
  compass_SSW: 'SSO',
  compass_SW: 'SO',
  compass_WSW: 'OSO',
  compass_W: 'O',
  compass_WNW: 'ONO',
  compass_NW: 'NO',
  compass_NNW: 'NNO',
  // Known warning types, one badge label each. Bureau-home locales use the
  // bureau’s official terminology. Unknown types fall back to the humanized
  // English code in every locale (see warningTypeLabel).
  warning_type_small_craft_advisory: 'Aviso para pequenas embarcações',
  warning_type_gale_warning: 'Aviso de temporal',
  warning_type_gale_watch: 'Vigilância de temporal',
  warning_type_storm_warning: 'Aviso de tempestade',
  warning_type_storm_watch: 'Vigilância de tempestade',
  warning_type_hurricane_force_wind_warning: 'Aviso de ventos com força de furacão',
  warning_type_hurricane_force_wind_watch: 'Vigilância de ventos com força de furacão',
  warning_type_special_marine_warning: 'Aviso marítimo especial',
  warning_type_marine_weather_statement: 'Comunicado meteorológico marítimo',
  warning_type_hazardous_seas_warning: 'Aviso de mar perigoso',
  warning_type_brisk_wind_advisory: 'Aviso de vento fresco',
  warning_type_low_water_advisory: 'Aviso de águas baixas',
  warning_type_dense_fog_advisory: 'Aviso de nevoeiro cerrado',
  warning_type_heavy_freezing_spray_warning: 'Aviso de salpicos congelantes fortes',
  warning_type_strong_wind_warning: 'Aviso de vento forte',
  warning_type_gale_force_wind_warning: 'Aviso de temporal',
  warning_type_storm_force_wind_warning: 'Aviso de tempestade',
  warning_type_wind_warning: 'Aviso de vento',
  warning_type_dense_fog_warning: 'Aviso de nevoeiro cerrado',
  warning_type_icing_warning: 'Aviso de formação de gelo',
  warning_type_typhoon_warning: 'Aviso de tufão',
  warning_type_wind_wave_warning: 'Aviso de ondulação forte',
  warning_type_wind_wave_advisory: 'Aviso preventivo de ondulação',
  warning_type_strong_wind_advisory: 'Aviso preventivo de vento forte',
  warning_type_storm_surge_warning: 'Aviso de maré de tempestade',
  warning_type_storm_surge_advisory: 'Aviso preventivo de maré de tempestade',
  warning_type_thunderstorm_warning: 'Aviso de trovoadas',
  warning_type_rough_sea_warning: 'Aviso de mar grosso',
  warning_type_fog_warning: 'Aviso de nevoeiro',
  sea_state_calm_rippled: 'Mar encrespado',
  sea_state_smooth: 'Mar chão',
  sea_state_slight: 'Mar pequeno',
  sea_state_moderate: 'Mar cavado',
  sea_state_rough: 'Mar grosso',
  sea_state_very_rough: 'Mar alteroso',
  sea_state_high: 'Mar grande',
  sea_state_very_high: 'Mar muito grande',
  sea_state_phenomenal: 'Mar excecional',
  hazard_showers: 'Aguaceiros',
  hazard_reduced_visibility: 'Visibilidade reduzida',
  hazard_haze: 'Névoa',
  hazard_waterspout: 'Trombas de água',
  hazard_freezing_spray: 'Salpicos gelados',
  hazard_ice: 'Gelo',
  marine_summary_sea_wind: '{{sea}}, vento de {{direction}} a {{speed}}.',
  marine_summary_wind_only_gusting: 'Vento de {{direction}} a {{speed}}, rajadas de {{gust}}.',
  marine_summary_sea_wind_gusting:
    '{{sea}}, vento de {{direction}} a {{speed}}, rajadas de {{gust}}.',
  marine_summary_wind_only: 'Vento de {{direction}} a {{speed}}.',
  marine_summary_sea_only: '{{sea}}.',
  marine_prediction_caveat_tide_one:
    'As previsões de maré são astronómicas, pelo que o tempo desse aviso pode subir ou descer o nível real.',
  marine_prediction_caveat_tide_many:
    'As previsões de maré são astronómicas, pelo que o tempo desses avisos pode subir ou descer o nível real.',
  marine_prediction_caveat_current_one:
    'As previsões de corrente são astronómicas, pelo que o tempo desse aviso pode reforçar ou enfraquecer a corrente real.',
  marine_prediction_caveat_current_many:
    'As previsões de corrente são astronómicas, pelo que o tempo desses avisos pode reforçar ou enfraquecer a corrente real.',
  marine_warning_active: 'Está em vigor um aviso à navegação para esta zona.',
  marine_warnings_active: 'Estão em vigor avisos à navegação para esta zona.',
  marine_warning_upcoming: 'Entra em vigor um aviso à navegação para esta zona em {{time}}.',
  marine_warnings_upcoming:
    'Entram em vigor avisos à navegação para esta zona a partir de {{time}}.',
  marine_summary_hazard_now: 'Neste momento: {{hazard}}.',
  marine_summary_hazard_later: 'Na previsão: {{hazard}}.',
  marine_tide_rising:
    'A maré está a {{height}} e a encher: próxima preia-mar {{next}} às {{time}}.',
  marine_tide_falling:
    'A maré está a {{height}} e a vazar: próxima baixa-mar {{next}} às {{time}}.',
  marine_current_flood: 'Próxima corrente de enchente {{speed}} às {{time}}.',
  marine_current_ebb: 'Próxima corrente de vazante {{speed}} às {{time}}.',
  marine_current_slack: 'Próxima estofa às {{time}}.',
  marine_current_now_flood: 'A corrente é de enchente a {{speed}}.',
  marine_current_now_ebb: 'A corrente é de vazante a {{speed}}.',
  marine_current_now_slack: 'A corrente está em estofa.',
  marine_current_peak: 'Máximo {{speed}} às {{time}}.',

  // --- Chart furniture (navaid / hazard / POI click popups) ---
  // See en.js for the rules these follow. "IALA A" / "IALA B" stay untranslated
  // in every language: it is the standard's name.
  furn_light: 'Luz',
  furn_buoy: 'Boia',
  furn_beacon: 'Baliza',
  furn_wreck: 'Naufrágio',
  furn_rock: 'Rocha',
  furn_obstruction: 'Obstrução',
  furn_anchorage: 'Fundeadouro',
  furn_tss: 'Dispositivo de separação de tráfego',
  furn_routing: 'Organização do tráfego',
  furn_title_buoy: 'Boia {{category}}',
  furn_title_beacon: 'Baliza {{category}}',
  furn_cat_port: 'de bombordo',
  furn_cat_starboard: 'de estibordo',
  furn_cat_preferred_channel_port: 'de canal preferencial a bombordo',
  furn_cat_preferred_channel_starboard: 'de canal preferencial a estibordo',
  furn_cat_safe_water: 'de águas seguras',
  furn_cat_isolated_danger: 'de perigo isolado',
  furn_cat_north: 'cardinal Norte',
  furn_cat_east: 'cardinal Este',
  furn_cat_south: 'cardinal Sul',
  furn_cat_west: 'cardinal Oeste',
  furn_cat_special: 'especial',
  furn_cat_mooring: 'de amarração',
  furn_cat_lateral: 'lateral',
  furn_characteristic: 'Característica',
  furn_range: 'Alcance',
  furn_height: 'Altura',
  furn_colour: 'Cor',
  furn_shape: 'Forma',
  furn_lights_on_mark: 'Luzes desta marca',
  furn_topmark: 'Marca de topo',
  furn_class: 'Classe',
  furn_least_depth_over: 'Profundidade mínima sobre',
  furn_depth_over: 'Profundidade sobre',
  furn_state: 'Estado',
  furn_type: 'Tipo',
  furn_range_value: '{{value}} M',
  furn_metres_value: '{{value}} m',
  furn_cable: 'Cabo submarino',
  furn_pipeline: 'Conduta submarina',
  furn_restricted_area: 'Área restrita',
  furn_restriction: 'Restrição',
  furn_mpa: 'Área marinha protegida',
  furn_protection: 'Proteção',
  furn_agency: 'Gerida por',
  furn_mpa_note: 'Uma designação de conservação, não uma restrição à navegação.',
  furn_sector: 'Setor',
  furn_sector_value: '{{from}}° → {{to}}°',
  lightw_f: 'Luz {{colour}} fixa.',
  lightw_fl: 'Relampeja em {{colour}} a cada {{period}} segundos.',
  lightw_fl_group: 'Relampeja em {{colour}} em grupos de {{count}}, a cada {{period}} segundos.',
  lightw_lfl: 'Um lampejo longo {{colour}} a cada {{period}} segundos.',
  lightw_q: 'Lampejos {{colour}}s rápidos.',
  lightw_iso: 'Luz {{colour}} e escuridão iguais, a cada {{period}} segundos.',
  lightw_oc: 'Luz {{colour}} fixa com breve ocultação a cada {{period}} segundos.',
  lightcolour_white: 'branca',
  lightcolour_red: 'vermelha',
  lightcolour_green: 'verde',
  lightcolour_yellow: 'amarela',
  furn_feet_charted_value: '{{feet}} ft ({{metres}} m na carta)',
  furn_light_yes: 'sim',
  furn_shown_neutral: '{{colours}} (mostrado em neutro)',
  furn_note_light: 'Aspeto da luz à noite: é assim que o navegante a identifica.',
  furn_note_lateral_b_port:
    'Marca o lado ESQUERDO do canal ao regressar do mar (IALA B: cilíndrica verde).',
  furn_note_lateral_b_starboard:
    'Marca o lado DIREITO do canal ao regressar do mar (IALA B: “vermelho à direita ao regressar”).',
  furn_note_lateral_a_port:
    'Marca o lado de BOMBORDO do canal ao entrar do mar (IALA A: vermelho a bombordo).',
  furn_note_lateral_a_starboard:
    'Marca o lado de ESTIBORDO do canal ao entrar do mar (IALA A: verde a estibordo).',
  furn_note_safe_water:
    'Águas seguras em toda a volta, normalmente a marca de aterragem ou de meio do canal.',
  furn_note_isolated_danger: 'Fundeada sobre um perigo isolado com água navegável à volta.',
  furn_note_cardinal_north: 'Marca cardinal: passe a NORTE dela.',
  furn_note_cardinal_east: 'Marca cardinal: passe a ESTE dela.',
  furn_note_cardinal_south: 'Marca cardinal: passe a SUL dela.',
  furn_note_cardinal_west: 'Marca cardinal: passe a OESTE dela.',
  furn_note_special: 'Marca especial (amarela): limites, cabos, amarrações, regatas.',
  furn_note_preferred_starboard: 'Marca de bifurcação: o canal preferido fica a estibordo.',
  furn_note_preferred_port: 'Marca de bifurcação: o canal preferido fica a bombordo.',
  furn_note_mooring: 'Boia de amarração.',
  furn_vessel: 'Navio',
  furn_depth_quality: 'Qualidade da sonda',
  furn_length: 'Comprimento',
  furn_position_accuracy: 'Precisão da posição',
  furn_remarks: 'Observações',
  furn_circumstances: 'Circunstâncias',
  furn_status: 'Estado',
  furn_note_shom: 'Cartografado pelo Shom (França). ©Shom, CC BY-SA 4.0.',
  furn_lock: 'Eclusa',
  furn_bridge: 'Ponte',
  furn_overhead_cable: 'Cabo aéreo',
  furn_notice_mark: 'Sinal de aviso',
  furn_distance_mark: 'Marca de distância',
  furn_daymark: 'Marca diurna',
  furn_channel: 'Canal',
  furn_vertical_clearance_closed: 'Altura livre (fechado)',
  furn_vertical_clearance_open: 'Altura livre (aberto)',
  furn_datum: 'Referência',
  furn_datum_value: '{plane} (VERDAT {code})',
  furn_datum_unknown: 'unknown code (VERDAT {code})',
  furn_note_ienc:
    'ENC fluvial (US Army Corps of Engineers). As alturas livres são medidas acima do plano de referência indicado; com o rio cheio a altura real é menor.',
  furn_note_wreck:
    'Naufrágio cartografado. As profundidades são valores da carta, não verificados.',
  furn_note_anchorage: 'Área de fundeadouro cartografada.',
  furn_note_tss:
    'Vias de navegação de sentido único. As embarcações pequenas atravessam perpendicularmente e mantêm-se afastadas.',
  furn_route: 'Rota',
  furn_fairway: 'Canal de navegação',
  furn_recommended_track: 'Rota recomendada',
  furn_navigation_line: 'Linha de navegação',
  furn_leading_line: 'Enfiamento',
  furn_clearing_line: 'Linha de segurança',
  furn_transit_line: 'Linha de trânsito',
  furn_traffic: 'Tráfego',
  furn_orientation: 'Orientação',
  furn_degrees_value: '{{value}}°',
  furn_note_fairway: 'Canal cartografado: a passagem mantida ou preferencial.',
  furn_note_track: 'Linha de rumo cartografada.',
  furn_note_track_fixed_marks: 'Linha de rumo cartografada, baseada em marcas fixas (enfiamentos).',
  furn_note_leading_line:
    'Mantenha as marcas de enfiamento alinhadas para seguir a linha cartografada.',
  furn_note_navigation_line: 'Linha de navegação cartografada.',
  furn_poi_marina: 'Marina',
  furn_poi_fuel: 'Combustível',
  furn_poi_slipway: 'Rampa de varadouro',
  furn_poi_ferry_terminal: 'Terminal de ferry',
  furn_poi_boatyard: 'Estaleiro',
  furn_poi_lighthouse: 'Farol',
  furn_note_slipway: 'Rampa de varadouro.',
  // Layers sheet — UNTRANSLATED, English placeholders (2026-09-11). Catalog
  // parity is enforced by scripts/check-locale-keys.mjs, so a key cannot be
  // added to en.js alone; these are placeholders awaiting translation, not
  // a claim that the strings are localized.
  layers: 'Layers',
  layers_close: 'Close layers',
  layers_map_type: 'Map type',
  layers_visualizations: 'Visualizations',
  layers_standard_map: 'Standard Map',
  layers_depth_chart: 'Depth Chart',
  layers_moving_tides: 'Moving Tides',
  layers_moving_currents: 'Moving Currents',
  layers_wind_waves: 'Wind & Waves',
  layers_weather_radar: 'Weather Radar',
  layers_coming_soon: 'Coming soon',
  layers_no_currents_here: 'No current stations in view',
  layers_no_radar_here: 'No radar coverage in view',
  // The compass button's accessible name. {{point}} is a 16-point direction
  // (SSW) and {{deg}} the exact bearing — the face rounds to 8 points, this
  // does not. English placeholder in the non-English catalogs, awaiting
  // translation; catalog parity is enforced by scripts/check-locale-keys.mjs.
  follow_my_direction: 'Seguir a minha orientação',
  compass_faces: 'Map faces {{point}} · {{deg}}°, tap for north-up',
  ww_row_no_data: '{{row}}: sem dados aqui',
  ww_row_no_forecast_after: '{{row}}: sem previsão depois de {{when}}',
  ww_row_no_forecast: '{{row}}: sem previsão tão longe',
  ww_unavailable: 'Dados do tempo indisponíveis',
  explore_show_player: 'Mostrar a linha de tempo',
  explore_hide_player: 'Ocultar a linha de tempo',

  // --- Route planning on /explore (see en.js for the wording rules; the
  // service's disclaimer is shown verbatim, route_disclaimer is only the
  // fallback). Marks are all feminine (boia, luz, baliza), so the colour agrees.
  route_plan: 'Planear uma rota',
  route_leave: 'Sair do planeamento de rotas',
  route_title: 'Rota',
  route_prompt_start: 'Toque na água onde vai partir.',
  route_prompt_start_desktop: 'Clique na água onde vai partir e depois clique no destino.',
  route_prompt_end: 'Partida definida. Agora toque no destino.',
  route_prompt_end_desktop: 'Partida definida. Agora clique no destino.',
  route_drag_hint: 'Os marcadores podem ser arrastados.',
  route_clear: 'Limpar',
  route_swap: 'Trocar partida e destino',
  route_share: 'Copiar ligação',
  route_copied: 'Ligação copiada',
  route_start: 'Partida',
  route_destination: 'Destino',
  route_near: 'perto de {{name}}',
  route_loading: 'A traçar a sua rota…',
  route_loading_sub: 'Normalmente um ou dois segundos. Algumas áreas demoram até 30 segundos.',
  route_loading_slow: 'Ainda a trabalhar…',
  route_loading_slow_sub: 'Esta área está a demorar mais do que o habitual.',
  route_summary_time: '{{duration}} a {{speed}}',
  route_planning_speed: 'Velocidade de planeamento',
  route_shoalest: 'Menor profundidade na rota',
  route_planning_draft: 'calado de planeamento',
  route_change: 'alterar',
  route_draft_title: 'Calado de planeamento',
  route_draft_help:
    'A profundidade para a qual a rota é planeada, não o calado do seu barco. Mais fundo encontra menos passagens; menos fundo encontra mais.',
  route_datum: 'Profundidades referidas ao zero hidrográfico (MLLW), sem maré aplicada.',
  route_unassured_note:
    'Os troços a laranja atravessam águas que a carta e o levantamento não resolvem abaixo de {{draft}}.',
  route_row_start: 'Partida {{label}}',
  route_row_heading: 'rumo {{course}}° ({{point}})',
  route_row_end: 'Chegada {{label}}',
  route_row_end_sub: 'fim da rota',
  route_turn_left: 'Vire à esquerda para {{course}}°',
  route_turn_right: 'Vire à direita para {{course}}°',
  route_bear_left: 'Ligeiramente à esquerda para {{course}}°',
  route_bear_right: 'Ligeiramente à direita para {{course}}°',
  route_then: '{{first}}, depois {{second}}',
  route_keep_mark: 'Mantenha a {{mark}} à sua {{hand}}',
  route_leave_channel: 'Saia do canal na {{mark}}',
  route_on_your: 'à sua {{hand}} ({{side}})',
  route_hand_left: 'esquerda',
  route_hand_right: 'direita',
  route_side_port: 'bombordo',
  route_side_starboard: 'estibordo',
  route_mark_buoy: 'boia {{color}} {{num}}',
  route_mark_light: 'luz {{color}} {{num}}',
  route_mark_daybeacon: 'baliza {{color}} {{num}}',
  route_mark_lighted: '{{mark}} (luminosa)',
  route_red: 'vermelha',
  route_green: 'verde',
  route_follow: 'Siga {{name}}',
  route_follow_two: 'Siga {{first}} e depois {{second}}',
  route_follow_channel: 'o canal {{name}}',
  route_follow_named: '{{name}}',
  route_follow_unnamed: 'o canal balizado',
  route_follow_marks: '{{count}} marcas',
  route_greens_on: 'verdes à sua {{hand}}',
  route_reds_on: 'vermelhas à sua {{hand}}',
  route_show_marks: 'Mostrar marcas',
  route_hide_marks: 'Ocultar marcas',
  route_why: 'Porque vira aqui?',
  route_turn_reason: 'Vira aqui porque {{reason}}',
  route_lights: 'Luzes ao alcance: {{lights}}',
  route_stretch_unassured: 'profundidade não resolvida abaixo de {{draft}}',
  route_stretch_rocky: 'entre rochas cartografadas',
  route_stretch_canal:
    'canal artificial: operação de eclusas, comportas e altura livre das pontes não modeladas',
  route_step_of: 'Passo {{n}} de {{total}}',
  route_all_steps: 'Todos os passos',
  route_prev_step: 'Passo anterior',
  route_next_step: 'Passo seguinte',
  route_minutes: '{{n}} min',
  route_hours: '{{h}} h',
  route_hours_minutes: '{{h}} h {{m}} min',
  route_err_on_land_origin: 'A partida está em terra cartografada',
  route_err_on_land_destination: 'O destino está em terra cartografada',
  route_err_on_land_origin_sub:
    'Arraste o marcador de partida para a água. Um sapal, uma praia ou um cais conta como terra na carta.',
  route_err_on_land_destination_sub:
    'Arraste o marcador de destino para a água. Um sapal, uma praia ou um cais conta como terra na carta.',
  route_err_no_route: 'Sem rota com um calado de planeamento de {{draft}}',
  route_err_no_route_sub:
    'Algures entre os dois pontos, a carta tem menos fundo do que {{draft}}. Um calado de planeamento menor pode encontrar uma passagem.',
  route_err_no_snap: 'Sem água cartografada perto de um dos pontos',
  route_err_no_snap_sub: 'Aproxime os marcadores de águas abertas.',
  route_err_outside: 'Por agora, o planeamento de rotas cobre águas dos EUA',
  route_err_outside_sub:
    'As rotas são construídas a partir de cartas da NOAA, por isso ambos os pontos têm de estar em águas dos EUA. Outras costas mais tarde.',
  route_err_timeout: 'O serviço de rotas demorou demasiado',
  route_err_timeout_sub: 'Algumas áreas demoram até 30 segundos e esta excedeu o tempo.',
  route_err_unavailable: 'O planeamento de rotas não está disponível de momento',
  route_err_unavailable_sub: 'Tente novamente daqui a pouco.',
  route_err_busy: 'Demasiados pedidos de rota',
  route_err_busy_sub: 'Aguarde um minuto e tente novamente.',
  route_try_again: 'Tentar novamente',
  route_disclaimer:
    'Não utilizar para navegação. Esta rota segue o canal balizado tal como cartografado; não é uma afirmação de águas seguras.',
  route_promo_title: 'Siga esta rota na app com o Go Mode',
  route_promo_body:
    'O Go Mode mantém o seu barco na carta com a distância até à próxima marca ou viragem, a profundidade debaixo de si e a maré e a corrente da estação mais próxima. No Tides Near Me para iPhone e Android, com subscrição.',
}
